import React, { useState,useEffect } from "react";
import Part1 from "../Materi/Pages/Pertidaksamaan/1/Part1";
import Part2 from "../Materi/Pages/Pertidaksamaan/2/Part2";
import Part3 from "../Materi/Pages/Pertidaksamaan/3/Part3";
import Part4 from "../Materi/Pages/Pertidaksamaan/4/Part4";
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';

import { Scrollbar } from "react-scrollbars-custom";

const ButtonNext = ({ click }) => {
	const [page, setPage] = useState(1);
	const nextPage = () => {
		if (page < 4) setPage(page + 1);
	};
	const previousPage = () => {
		if (page > 1) setPage(page - 1);
	};

	const rumus = () => {
		if (page === 1) {
			return <Part1 />;
		} else if (page === 2) {
			return <Part2 />;
		} else if (page === 3) {
			return <Part3 />;
		} else {
			return <Part4 />;
		}
	};
	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	return (
		<div className="container-fluid">
			{/* <div className="row d-flex justify-content-center align-items-center "> */}
			<div
				style={{
					display: "flex",
					justifyContent: click ? "flex-end" : "center",
					alignItems: "center",
					transition:"all 1.0s ease;"
				}}
			>
				{/* <div className="col-lg-12">                     */}
				{/* <div style={{border:'3px solid black'}} className="">Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet, dolor. Perferendis officia molestias sit sed architecto facilis nemo quas maxime numquam, magnam ratione adipisci? Nemo provident illo consequuntur eum voluptate!</div> */}
				<Scrollbar
				
					style={
						click
							? { width: "85%", height: 550 }
							: { width: "95%", height: 550 }
					
						}
				>
					{rumus()}
				</Scrollbar>

				{/* </div> */}
			</div>

			<div className="row d-flex justify-content-center align-items-center mb-1">
				<div className="col-lg-10  ">
					<div
						style={{
							marginTop: "1rem",
							display: "flex",
                            justifyContent: "space-between",
                            // width: click ? "50%" : "100%",
						
						}}
					>
						<button
							className="btn btn-success"
							onClick={() => previousPage()}
							disabled={page === 1 ? true : false}
						>
							<SkipPreviousIcon />
						</button>
						<button
							className="btn btn-success"
							onClick={() => nextPage()}
							disabled={page === 4 ? true : false}
						>
							<SkipNextIcon />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ButtonNext;
